import { style } from "typestyle";
import * as Style from "../../styles";

export const component = style({
  background:
    "linear-gradient(180deg, #BD42C8 0%, rgba(195, 78, 205, 0.56) 100%)",
  whiteSpace: "nowrap",
  $nest: {
    "&:focus": {
      outline: "none",
    },
    "&:hover": {
      backgroundColor: Style.colors.secondary,
    },
  },
  transition: ".2s ease-in",
  textDecoration: "none",
  outline: "none",
  color: Style.colors.white,
  padding: `12px 18px`,
  fontSize: Style.text.fontSize.medium,
  borderRadius: "2px",
  border: "none",
  cursor: "pointer",
});

export const dark = style({
  backgroundColor: Style.colors.black1,
  borderColor: Style.colors.translucent150,
  $nest: {
    "&:hover": {
      backgroundColor: Style.colors.darkTranslucent650,
    },
  },
  background: "none",
});

export const rounded = style({
  borderRadius: 16,
});
